/** @deprecated use WorkoutType in shared/models/src/workout/IUserWorkoutSessionTypes.ts */
export enum WorkoutType { // number is the cycles, e.g. one in 2 minutes
  MediumStudioWorkout = 14, // 12 zones + 1 warmup + 1 warm down
  FullStudioWorkout = 23, //  20 zones + 2 warmup + 1 warmdown
  QuickStaticFunctionalWorkout = 7, // 5 zones + 1 warmup + 1 warmdown
  QuickHomeOrStaticCardioWorkout = 6, // 4 zones + 1 warmup + 1 warmdown
  MediumHomeOrStaticCardioWorkout = 11, // 2 x 4 zones + 1 warmup + 1 warmdown + 1 pauses
  FullHomeOrStaticCardioWorkout = 16, // 3 x 4 zones + 1 warmup + 1 warmdown + 2 pauses
  ExtraLongHomeOrStaticCardioWorkout = 21, // 4 x 4 zones + 1 warmup + 1 warmdown + 3 pauses
  FullStaticCardioWorkout = 26,
  ImportedWorkout = 1,
}

export const homeWorkoutTypes: WorkoutType[] = [
  WorkoutType.QuickHomeOrStaticCardioWorkout,
  WorkoutType.MediumHomeOrStaticCardioWorkout,
  WorkoutType.FullHomeOrStaticCardioWorkout,
];
